import { render, staticRenderFns } from "./Localizacao.vue?vue&type=template&id=6522eb63&scoped=true&"
import script from "./Localizacao.vue?vue&type=script&lang=js&"
export * from "./Localizacao.vue?vue&type=script&lang=js&"
import style0 from "./Localizacao.vue?vue&type=style&index=0&id=6522eb63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522eb63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
